module.exports = __webpack_public_path__ + "img/moble_home1.02983070.png";